import React from "react";
import styles from "../products/checkout/style.module.css";
import { Box, Button, Typography } from "@mui/material";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { useHistory } from "react-router-dom";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { toast } from "../../utils/toastsMessage";
import ClipLoader from "react-spinners/ClipLoader";

const AdPaymentMethod: React.FC<any> = (props: any) => {
  const {
    totalAmount,
    budgetPerDay,
    isEdit,
    adCenterStep1Data,
    onSubmitAdData,
    isDisabled,
    isConfirm,
    setIsConfirm,
    setIsDisabled,
  } = props;

  const stripe = useStripe();
  const elements = useElements();
  const commonStyle = UserCommonStyles();

  const onSubmit = async () => {
    if (isConfirm?.confirm) {
      setIsDisabled(true);
      const stripe_data = {
        email: adCenterStep1Data?.email,
        name: adCenterStep1Data?.company_name,
        phone: adCenterStep1Data?.phone_number,
      };
  
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: stripe_data,
      });
      if (error) {
        setIsDisabled(false);
        return toast.error(error.message ? error.message : "");
      } else if (!error && paymentMethod?.id) {
        onSubmitAdData(paymentMethod, error, setIsDisabled);
      } else {
        setIsDisabled(false);
        return toast.error("Something went wrong. Please try again later.");
      }
    } else {
      setIsConfirm({confirm: false, message: "Please accept this condition to move forward with the agreement."})
    }
    
  };

  return (
    <>
      <Typography
        variant="h6"
        className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.f_family_Roboto} ${commonStyle.font22}`}
      >
        Payment details
      </Typography>
      <CardElement
        className={styles.card_element}
        options={{
          style: {
            base: {
              fontSize: "20px",
              color: "#32325d",
              fontFamily:
                "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
              "::placeholder": {
                color: "#a0aec0",
              },
            },
            invalid: {
              color: "#9e2146",
              backgroundColor: "#f5d4d3",
            },
          },
        }}
      />

      <Box mt={4} mb={10} className={` ${commonStyle.blueBtn} `}>
        <Button
          fullWidth
          disabled={isDisabled}
          style={{
            fontFamily: "Roboto",
            fontWeight: "500",
            fontSize: "20px",
            alignItems: "center",
            color: "#fff",
          }}
          onClick={onSubmit}
        >
          Publish{isDisabled ? <ClipLoader /> : null}
        </Button>
      </Box>
    </>
  );
};

export default AdPaymentMethod;
